export * from '../services/order.service';
export * from './orders.component';
export * from './order.routes';
export * from './order-detail/index'


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/fulfillment.release/src/app/orders/index.ts